export const location = state => state.location
export const userInfo = state => state.userInfo
